import { withCompanyName } from '@routes/-withCompanyName'
import { createFileRoute, Outlet } from '@tanstack/react-router'
import { z } from 'zod/v4'

export const unsubscribeSchema = z.object({
  unsubscribeId: z.string().optional(),
  emailType: z.string().optional(),
})

export type UnsubscribeSchemaSearch = z.infer<typeof unsubscribeSchema>

export const Route = createFileRoute('/unsubscribe')({
  component: Outlet,
  validateSearch: unsubscribeSchema,
  head: () => ({
    meta: [
      {
        title: withCompanyName('Unsubscribe from email'),
      },
    ],
  }),
})
